import React, { useMemo, useState, useEffect } from "react";
import MaterialReactTable from "material-react-table";
import Cookies from "universal-cookie";
import axios from "axios";

import { Box, Typography } from "@mui/material";

import { MDBBtn, MDBCollapse } from "mdb-react-ui-kit";
import { MRT_Localization_ES } from "material-react-table/locales/es";
const GestionarOm = (props) => {
  const cookie = new Cookies();
  if (cookie.get("tipo_Usuario") == 1) {
    var urlendpoint =
      "https://suadesarrollo.azurewebsites.net/api/ObtenerOmCategorizado/0/Primario";
  }
  if (cookie.get("tipo_Usuario") == 2) {
    var urlendpoint =
      "https://suadesarrollo.azurewebsites.net/api/ObtenerOmCategorizado/" +
      cookie.get("institucionid") +
      "/Primario";
  }
  if (cookie.get("tipo_Usuario") == 3) {
    var urlendpoint =
      "https://suadesarrollo.azurewebsites.net/api/ObtenerOmCategorizado/" +
      cookie.get("institucionid") +
      "/Primario";
  }
  if (cookie.get("tipo_Usuario") == 4)
    var urlendpoint =
      "https://suadesarrollo.azurewebsites.net/api/ObtenerOmCategorizado/0";
  const [modalIsOpen, setIsOpen] = useState(false);
  const handleOpenModalTest = () => {
    setIsOpen(true);
  };
  const closeModal = () => {
    setIsOpen(false);
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "id",
        header: "Id",
        filterVariant: "text",
        enableEditing: false,
      },
      {
        accessorKey: "prioriza",
        header: "Priorización",
        filterVariant: "dateTime",
      },
      {
        accessorKey: "categorizado",
        header: "Categoria",
        filterVariant: "text",
      },

      {
        accessorKey: "origen",
        header: "Origen",
        filterVariant: "text",
        enableEditing: false,
      },
      {
        accessorKey: "nConsecutivo",
        header: "Numero Consecutivo",
        filterVariant: "text",
        enableEditing: false,
      },
      {
        accessorKey: "consecutivosSimilares",
        header: "Consecutivos Similares",
        filterVariant: "text",
        enableEditing: false,
      },
      {
        accessorKey: "Descripcion",
        header: "descripcion",
        filterVariant: "text",
        enableEditing: false,
      },
      {
        accessorKey: "institucionId",
        header: "institucionId",
        filterVariant: "text",
        enableEditing: false,
      },
      {
        accessorKey: "sedeId",
        header: "Sede id",
        filterVariant: "text",
        enableEditing: false,
      },
    ],
    [],
  );
  const [list1, setList1] = useState([]);

  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: urlendpoint,
    })
      .then((Response) => {
        setList1(Response.data);

        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList1]);

  const [showShow, setShowShow] = useState(false);
  const toggleShow = () => setShowShow(!showShow);

  const [showShow1, setShowShow1] = useState(false);
  const toggleShow1 = () => setShowShow1(!showShow1);

  const [tableData, setTableData] = useState(() => list1);
  const handleSaveRow = async ({ exitEditingMode, row, values }) => {
    axios({
      method: "put",
      url:
        "https://suadesarrollo.azurewebsites.net/api/ActualizaCategoria/" +
        values.id,
      data: values,
    })
      .then((Response) => {
        console.log(Response.data);
        alert("Actualizado con exito!");
        window.location.reload("/");
      })
      .catch((error) => {
        console.log(error);
        alert("Error al Actualizar" + error);
      });

    //send/receive api updates here
    setTableData([...tableData]);
    exitEditingMode(); //required to exit editing mode
    console.log("post data ");
    console.log(values.id);
  };

  const [valor, setValor] = useState([]);
  const [sleccionado, setSeleccionado] = useState([]);
  console.log("seleccionado" + valor);

  const postData = (e) => {
    e.preventDefault(e);
    window.location.href = "/#/Agrupadas/" + valor;
  };
  return (
    <div>
      <div className="container">
        <div className="text-center">
          <div class="container-fluid">
            <div class="card shadow mb-4">
              <div class="card-header py-3">
                <h6 class="m-0 font-weight-bold text-primary">
                  Oportunidades{cookie.get("institucionid")}
                </h6>
              </div>

              <MDBBtn
                outline
                className="btn btn-light btn-user btn-block"
                onClick={toggleShow1}
              >
                <center>Información OM Primarias</center>
              </MDBBtn>
              <MDBCollapse show={showShow1}>
                <MaterialReactTable
                  title="indicadores"
                  localization={MRT_Localization_ES}
                  columns={columns}
                  data={list1}
                  initialState={{ showColumnFilters: true }}
                  enableRowActions
                  enableRowSelection
                  positionToolbarAlertBanner="bottom"
                  editingMode="modal" //default
                  enableEditing
                  enableMultiRowSelection={false}
                  onEditingRowSave={handleSaveRow}
                  enableExpanding={true}
                  enableExpandAll={true} //default
                  renderDetailPanel={({ row }) => (
                    <Box
                      sx={{
                        display: "grid",
                        margin: "auto",
                        gridTemplateColumns: "1fr 1fr",
                        width: "100%",
                      }}
                    >
                      <Typography>
                        <b>Descripción:</b> {row.original.descripcion}
                      </Typography>
                      <Typography>-</Typography>
                      <Typography>
                        <b>Descripción Om Similar:</b>{" "}
                        {row.original.descripcionOmSimilar}
                      </Typography>
                    </Box>
                  )}
                  renderTopToolbarCustomActions={({ table }) => {
                    const handleDeactivate = () => {
                      table.getSelectedRowModel().flatRows.map((row) => {
                        alert("deactivating " + row.getValue("id"));
                        setSeleccionado(row.getValue("id"));
                        axios({
                          method: "put",
                          url:
                            "https://suadesarrollo.azurewebsites.net/api/ActualizaCategorizacion/" +
                            props.padre,
                          data: {
                            prioriza: props.padre,
                          },
                        })
                          .then((Response) => {
                            console.log(Response.data);
                            alert("Actualizado con exito!");
                            window.location.reload("/");
                          })
                          .catch((error) => {
                            console.log(error);
                            alert("Error al Actualizar" + error);
                          });
                      });
                    };
                    const elemnto = table
                      .getSelectedRowModel()
                      .flatRows.map((row) => {
                        row.getValue("id");
                        setValor(row.getValue("id"));
                      });
                    console.log(valor);
                  }}
                />
              </MDBCollapse>
              <hr />

              <button
                className="btn btn-primary btn-user btn-block "
                onClick={postData}
              >
                Gestionar om con id {valor}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GestionarOm;
